export var isClient = function () {
    return typeof document !== 'undefined';
};
export var getFontSizePixelValue = function (element) {
    if (!isClient())
        return undefined;
    return parseFloat(getComputedStyle(element !== null && element !== void 0 ? element : document.documentElement).fontSize);
};
export var getViewWidthPixelValue = function () {
    if (!isClient())
        return undefined;
    return window.parent.screen.width;
};
export var getViewHeightPixelValue = function () {
    if (!isClient())
        return undefined;
    return window.parent.screen.height;
};
//# sourceMappingURL=helpers.js.map